const CHART_WIDTH = 500;
const CHART_HEIGHT = 500;
const CHART_MARGIN = 40;
const CHART_RADIUS = Math.min(CHART_WIDTH, CHART_HEIGHT) / 2 - CHART_MARGIN;

export const design = {
  ClockPieChart: {
    HEIGHT: CHART_HEIGHT,
    MARGIN: CHART_MARGIN,
    RADIUS: CHART_RADIUS,
    WIDTH: CHART_WIDTH,
  },
} as const;
